var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vuex-breadcrumb'),_c('product-listing-show',{attrs:{"id":_vm.id},on:{"gotAttrs":_vm.assignAttrs}}),_c('product-item-index',{attrs:{"filtering":_vm.filtering,"ams_template":_vm.ams_template}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }